import { Button, Group, Text } from '@mantine/core';

import { IScudLocationCount } from '@/shared/types/scudMapping.types';

type ScudQueueBarProps = {
	items: IScudLocationCount[];
	/** Локация, по которой сейчас отфильтрован список */
	active: string | null;
	onSelect: (location: string) => void;
};

/** Необработанные по локациям; клик оставляет в списке одну локацию, повторный снимает отбор */
export const ScudQueueBar = ({ items, active, onSelect }: ScudQueueBarProps) => {
	const queue = items.filter((item) => item.count > 0).sort((a, b) => b.count - a.count);

	if (!queue.length) {
		return null;
	}

	return (
		<Group gap={6}>
			<Text size="sm" c="dimmed">
				Необработанные по локациям:
			</Text>
			{queue.map((item) => {
				const isActive = item.location === active;

				return (
					<Button
						key={item.location}
						size="compact-md"
						radius="xl"
						variant={isActive ? 'light' : 'default'}
						fw={500}
						aria-pressed={isActive}
						onClick={() => onSelect(item.location)}
					>
						{item.location}
						<Text span inherit fw={800} c="orange.7" ml={6}>
							{item.count}
						</Text>
					</Button>
				);
			})}
		</Group>
	);
};
